import has from "lodash/has";
export default (data) => has(data, "Latitude") && has(data, "Longitude");
